import { MoreMenu } from 'components/MoreMenu';
import { lodash } from 'helpers';
import { TFunc } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';
import { Colors } from 'libs/ui/theme';

import { WithdrawalAccountItem, WithdrawalAccountOptionType } from '../types';

export const renderMore = (
  t: TFunc,
  item: WithdrawalAccountItem,
  shownOptions: Partial<Record<WithdrawalAccountOptionType, boolean>>,
  onClickOption: (
    item: WithdrawalAccountItem,
    option: WithdrawalAccountOptionType
  ) => void
) => (
  <MoreMenu
    options={lodash.compact([
      shownOptions.delete && {
        value: WithdrawalAccountOptionType.delete,
        label: t('common.delete'),
        Icon: Icon.Bucket,
        color: Colors.red,
      },
    ])}
    variant="horizontal"
    onClickOption={(option) => onClickOption(item, option.value)}
  />
);
